import { useContext, useMemo } from "react";
import { DataContext } from "../context/DataContext";

// Import IDMatchPlus locale files
import idmatchplusEn from "../locales/idmatchplus/en.json";
import idmatchplusEs from "../locales/idmatchplus/es.json";

// Import Brazil CPF locale files
import brazilCpfAr from "../locales/brazil-cpf/ar.json";
import brazilCpfBg from "../locales/brazil-cpf/bg.json";
import brazilCpfBs from "../locales/brazil-cpf/bs.json";
import brazilCpfCs from "../locales/brazil-cpf/cs.json";
import brazilCpfDa from "../locales/brazil-cpf/da.json";
import brazilCpfDe from "../locales/brazil-cpf/de.json";
import brazilCpfEl from "../locales/brazil-cpf/el.json";
import brazilCpfEn from "../locales/brazil-cpf/en.json";
import brazilCpfEs419 from "../locales/brazil-cpf/es-419.json";
import brazilCpfEs from "../locales/brazil-cpf/es.json";
import brazilCpfEt from "../locales/brazil-cpf/et.json";
import brazilCpfFa from "../locales/brazil-cpf/fa.json";
import brazilCpfFi from "../locales/brazil-cpf/fi.json";
import brazilCpfFr from "../locales/brazil-cpf/fr.json";
import brazilCpfHe from "../locales/brazil-cpf/he.json";
import brazilCpfHi from "../locales/brazil-cpf/hi.json";
import brazilCpfHr from "../locales/brazil-cpf/hr.json";
import brazilCpfHu from "../locales/brazil-cpf/hu.json";
import brazilCpfHy from "../locales/brazil-cpf/hy.json";
import brazilCpfId from "../locales/brazil-cpf/id.json";
import brazilCpfIt from "../locales/brazil-cpf/it.json";
import brazilCpfJa from "../locales/brazil-cpf/ja.json";
import brazilCpfKo from "../locales/brazil-cpf/ko.json";
import brazilCpfLt from "../locales/brazil-cpf/lt.json";
import brazilCpfLv from "../locales/brazil-cpf/lv.json";
import brazilCpfMs from "../locales/brazil-cpf/ms.json";
import brazilCpfNb from "../locales/brazil-cpf/nb.json";
import brazilCpfNl from "../locales/brazil-cpf/nl.json";
import brazilCpfPl from "../locales/brazil-cpf/pl.json";
import brazilCpfPtBR from "../locales/brazil-cpf/pt-BR.json";
import brazilCpfPt from "../locales/brazil-cpf/pt.json";
import brazilCpfRo from "../locales/brazil-cpf/ro.json";
import brazilCpfRu from "../locales/brazil-cpf/ru.json";
import brazilCpfSk from "../locales/brazil-cpf/sk.json";
import brazilCpfSrLatnRS from "../locales/brazil-cpf/sr-Latn-RS.json";
import brazilCpfSrRS from "../locales/brazil-cpf/sr-RS.json";
import brazilCpfSv from "../locales/brazil-cpf/sv.json";
import brazilCpfTh from "../locales/brazil-cpf/th.json";
import brazilCpfTl from "../locales/brazil-cpf/tl.json";
import brazilCpfTr from "../locales/brazil-cpf/tr.json";
import brazilCpfUk from "../locales/brazil-cpf/uk.json";
import brazilCpfUr from "../locales/brazil-cpf/ur.json";
import brazilCpfVi from "../locales/brazil-cpf/vi.json";
import brazilCpfZh from "../locales/brazil-cpf/zh.json";

// Import AgeMatch locale files
import agematchAr from "../locales/agematch/ar.json";
import agematchBg from "../locales/agematch/bg.json";
import agematchBs from "../locales/agematch/bs.json";
import agematchCs from "../locales/agematch/cs.json";
import agematchDa from "../locales/agematch/da.json";
import agematchDe from "../locales/agematch/de.json";
import agematchEl from "../locales/agematch/el.json";
import agematchEn from "../locales/agematch/en.json";
import agematchEs419 from "../locales/agematch/es-419.json";
import agematchEs from "../locales/agematch/es.json";
import agematchEt from "../locales/agematch/et.json";
import agematchFa from "../locales/agematch/fa.json";
import agematchFi from "../locales/agematch/fi.json";
import agematchFr from "../locales/agematch/fr.json";
import agematchHe from "../locales/agematch/he.json";
import agematchHi from "../locales/agematch/hi.json";
import agematchHr from "../locales/agematch/hr.json";
import agematchHu from "../locales/agematch/hu.json";
import agematchHy from "../locales/agematch/hy.json";
import agematchId from "../locales/agematch/id.json";
import agematchIt from "../locales/agematch/it.json";
import agematchJa from "../locales/agematch/ja.json";
import agematchKo from "../locales/agematch/ko.json";
import agematchLt from "../locales/agematch/lt.json";
import agematchLv from "../locales/agematch/lv.json";
import agematchMs from "../locales/agematch/ms.json";
import agematchNb from "../locales/agematch/nb.json";
import agematchNl from "../locales/agematch/nl.json";
import agematchPl from "../locales/agematch/pl.json";
import agematchPtBR from "../locales/agematch/pt-BR.json";
import agematchPt from "../locales/agematch/pt.json";
import agematchRo from "../locales/agematch/ro.json";
import agematchRu from "../locales/agematch/ru.json";
import agematchSk from "../locales/agematch/sk.json";
import agematchSrLatnRS from "../locales/agematch/sr-Latn-RS.json";
import agematchSrRS from "../locales/agematch/sr-RS.json";
import agematchSv from "../locales/agematch/sv.json";
import agematchTh from "../locales/agematch/th.json";
import agematchTl from "../locales/agematch/tl.json";
import agematchTr from "../locales/agematch/tr.json";
import agematchUk from "../locales/agematch/uk.json";
import agematchUr from "../locales/agematch/ur.json";
import agematchVi from "../locales/agematch/vi.json";
import agematchZh from "../locales/agematch/zh.json";

// Import mojeID locale files
import mojeidEn from "../locales/mojeid/en.json";
import mojeidCs from "../locales/mojeid/cs.json";

// Import BankID CZ locale files
import bankidCzEn from "../locales/bankid-cz/en.json";
import bankidCzCs from "../locales/bankid-cz/cs.json";

// Import BankID Sweden locale files
import bankidSeEn from "../locales/bankid-se/en.json";
import bankidSeSv from "../locales/bankid-se/sv.json";

// Import BankID Norway locale files
import bankidNoEn from "../locales/bankid-no/en.json";
import bankidNoNb from "../locales/bankid-no/nb.json";

// Import Finnish Trust Network locale files
import finnishTrustNetworkEn from "../locales/finnish-trust-network/en.json";
import finnishTrustNetworkFi from "../locales/finnish-trust-network/fi.json";

// Import Modular locale files
import modularEn from "../locales/modular/en.json";
import modularCs from "../locales/modular/cs.json";
import modularFi from "../locales/modular/fi.json";

// Import Device Blocked locale files
import deviceBlockedEn from "../locales/device-blocked/en.json";
import deviceBlockedAr from "../locales/device-blocked/ar.json";
import deviceBlockedBg from "../locales/device-blocked/bg.json";
import deviceBlockedBs from "../locales/device-blocked/bs.json";
import deviceBlockedCs from "../locales/device-blocked/cs.json";
import deviceBlockedDa from "../locales/device-blocked/da.json";
import deviceBlockedDe from "../locales/device-blocked/de.json";
import deviceBlockedEl from "../locales/device-blocked/el.json";
import deviceBlockedEs from "../locales/device-blocked/es.json";
import deviceBlockedEs419 from "../locales/device-blocked/es-419.json";
import deviceBlockedEt from "../locales/device-blocked/et.json";
import deviceBlockedFa from "../locales/device-blocked/fa.json";
import deviceBlockedFi from "../locales/device-blocked/fi.json";
import deviceBlockedFr from "../locales/device-blocked/fr.json";
import deviceBlockedHe from "../locales/device-blocked/he.json";
import deviceBlockedHi from "../locales/device-blocked/hi.json";
import deviceBlockedHr from "../locales/device-blocked/hr.json";
import deviceBlockedHu from "../locales/device-blocked/hu.json";
import deviceBlockedHy from "../locales/device-blocked/hy.json";
import deviceBlockedId from "../locales/device-blocked/id.json";
import deviceBlockedIt from "../locales/device-blocked/it.json";
import deviceBlockedJa from "../locales/device-blocked/ja.json";
import deviceBlockedKo from "../locales/device-blocked/ko.json";
import deviceBlockedLt from "../locales/device-blocked/lt.json";
import deviceBlockedLv from "../locales/device-blocked/lv.json";
import deviceBlockedMs from "../locales/device-blocked/ms.json";
import deviceBlockedNb from "../locales/device-blocked/nb.json";
import deviceBlockedNl from "../locales/device-blocked/nl.json";
import deviceBlockedPl from "../locales/device-blocked/pl.json";
import deviceBlockedPt from "../locales/device-blocked/pt.json";
import deviceBlockedPtBR from "../locales/device-blocked/pt-BR.json";
import deviceBlockedRo from "../locales/device-blocked/ro.json";
import deviceBlockedRu from "../locales/device-blocked/ru.json";
import deviceBlockedSk from "../locales/device-blocked/sk.json";
import deviceBlockedSrRS from "../locales/device-blocked/sr-RS.json";
import deviceBlockedSrLatnRS from "../locales/device-blocked/sr-Latn-RS.json";
import deviceBlockedSv from "../locales/device-blocked/sv.json";
import deviceBlockedTh from "../locales/device-blocked/th.json";
import deviceBlockedTl from "../locales/device-blocked/tl.json";
import deviceBlockedTr from "../locales/device-blocked/tr.json";
import deviceBlockedUk from "../locales/device-blocked/uk.json";
import deviceBlockedUr from "../locales/device-blocked/ur.json";
import deviceBlockedVi from "../locales/device-blocked/vi.json";
import deviceBlockedZh from "../locales/device-blocked/zh.json";

// Import Orientation (rotate-device) locale files
import orientationEn from "../locales/orientation/en.json";
import orientationAr from "../locales/orientation/ar.json";
import orientationBg from "../locales/orientation/bg.json";
import orientationBs from "../locales/orientation/bs.json";
import orientationCs from "../locales/orientation/cs.json";
import orientationDa from "../locales/orientation/da.json";
import orientationDe from "../locales/orientation/de.json";
import orientationEl from "../locales/orientation/el.json";
import orientationEs from "../locales/orientation/es.json";
import orientationEs419 from "../locales/orientation/es-419.json";
import orientationEt from "../locales/orientation/et.json";
import orientationFa from "../locales/orientation/fa.json";
import orientationFi from "../locales/orientation/fi.json";
import orientationFr from "../locales/orientation/fr.json";
import orientationHe from "../locales/orientation/he.json";
import orientationHi from "../locales/orientation/hi.json";
import orientationHr from "../locales/orientation/hr.json";
import orientationHu from "../locales/orientation/hu.json";
import orientationHy from "../locales/orientation/hy.json";
import orientationId from "../locales/orientation/id.json";
import orientationIt from "../locales/orientation/it.json";
import orientationJa from "../locales/orientation/ja.json";
import orientationKo from "../locales/orientation/ko.json";
import orientationLt from "../locales/orientation/lt.json";
import orientationLv from "../locales/orientation/lv.json";
import orientationMs from "../locales/orientation/ms.json";
import orientationNb from "../locales/orientation/nb.json";
import orientationNl from "../locales/orientation/nl.json";
import orientationPl from "../locales/orientation/pl.json";
import orientationPt from "../locales/orientation/pt.json";
import orientationPtBR from "../locales/orientation/pt-BR.json";
import orientationRo from "../locales/orientation/ro.json";
import orientationRu from "../locales/orientation/ru.json";
import orientationSk from "../locales/orientation/sk.json";
import orientationSrRS from "../locales/orientation/sr-RS.json";
import orientationSrLatnRS from "../locales/orientation/sr-Latn-RS.json";
import orientationSv from "../locales/orientation/sv.json";
import orientationTh from "../locales/orientation/th.json";
import orientationTl from "../locales/orientation/tl.json";
import orientationTr from "../locales/orientation/tr.json";
import orientationUk from "../locales/orientation/uk.json";
import orientationUr from "../locales/orientation/ur.json";
import orientationVi from "../locales/orientation/vi.json";
import orientationZh from "../locales/orientation/zh.json";

// Import Handoff locale files
import handoffEn from "../locales/handoff/en.json";
import handoffAr from "../locales/handoff/ar.json";
import handoffBg from "../locales/handoff/bg.json";
import handoffBs from "../locales/handoff/bs.json";
import handoffCs from "../locales/handoff/cs.json";
import handoffDa from "../locales/handoff/da.json";
import handoffDe from "../locales/handoff/de.json";
import handoffEl from "../locales/handoff/el.json";
import handoffEs from "../locales/handoff/es.json";
import handoffEs419 from "../locales/handoff/es-419.json";
import handoffEt from "../locales/handoff/et.json";
import handoffFa from "../locales/handoff/fa.json";
import handoffFi from "../locales/handoff/fi.json";
import handoffFr from "../locales/handoff/fr.json";
import handoffHe from "../locales/handoff/he.json";
import handoffHi from "../locales/handoff/hi.json";
import handoffHr from "../locales/handoff/hr.json";
import handoffHu from "../locales/handoff/hu.json";
import handoffHy from "../locales/handoff/hy.json";
import handoffId from "../locales/handoff/id.json";
import handoffIt from "../locales/handoff/it.json";
import handoffJa from "../locales/handoff/ja.json";
import handoffKo from "../locales/handoff/ko.json";
import handoffLt from "../locales/handoff/lt.json";
import handoffLv from "../locales/handoff/lv.json";
import handoffMs from "../locales/handoff/ms.json";
import handoffNb from "../locales/handoff/nb.json";
import handoffNl from "../locales/handoff/nl.json";
import handoffPl from "../locales/handoff/pl.json";
import handoffPt from "../locales/handoff/pt.json";
import handoffPtBR from "../locales/handoff/pt-BR.json";
import handoffRo from "../locales/handoff/ro.json";
import handoffRu from "../locales/handoff/ru.json";
import handoffSk from "../locales/handoff/sk.json";
import handoffSrRS from "../locales/handoff/sr-RS.json";
import handoffSrLatnRS from "../locales/handoff/sr-Latn-RS.json";
import handoffSv from "../locales/handoff/sv.json";
import handoffTh from "../locales/handoff/th.json";
import handoffTl from "../locales/handoff/tl.json";
import handoffTr from "../locales/handoff/tr.json";
import handoffUk from "../locales/handoff/uk.json";
import handoffUr from "../locales/handoff/ur.json";
import handoffVi from "../locales/handoff/vi.json";
import handoffZh from "../locales/handoff/zh.json";

// Import COPPA locale files
import coppaEn from "../locales/coppa/en.json";
import coppaAr from "../locales/coppa/ar.json";
import coppaBg from "../locales/coppa/bg.json";
import coppaBs from "../locales/coppa/bs.json";
import coppaCs from "../locales/coppa/cs.json";
import coppaDa from "../locales/coppa/da.json";
import coppaDe from "../locales/coppa/de.json";
import coppaEl from "../locales/coppa/el.json";
import coppaEs from "../locales/coppa/es.json";
import coppaEs419 from "../locales/coppa/es-419.json";
import coppaEt from "../locales/coppa/et.json";
import coppaFa from "../locales/coppa/fa.json";
import coppaFi from "../locales/coppa/fi.json";
import coppaFr from "../locales/coppa/fr.json";
import coppaHe from "../locales/coppa/he.json";
import coppaHi from "../locales/coppa/hi.json";
import coppaHr from "../locales/coppa/hr.json";
import coppaHu from "../locales/coppa/hu.json";
import coppaHy from "../locales/coppa/hy.json";
import coppaId from "../locales/coppa/id.json";
import coppaIt from "../locales/coppa/it.json";
import coppaJa from "../locales/coppa/ja.json";
import coppaKo from "../locales/coppa/ko.json";
import coppaLt from "../locales/coppa/lt.json";
import coppaLv from "../locales/coppa/lv.json";
import coppaMs from "../locales/coppa/ms.json";
import coppaNb from "../locales/coppa/nb.json";
import coppaNl from "../locales/coppa/nl.json";
import coppaPl from "../locales/coppa/pl.json";
import coppaPt from "../locales/coppa/pt.json";
import coppaPtBR from "../locales/coppa/pt-BR.json";
import coppaRo from "../locales/coppa/ro.json";
import coppaRu from "../locales/coppa/ru.json";
import coppaSk from "../locales/coppa/sk.json";
import coppaSrRS from "../locales/coppa/sr-RS.json";
import coppaSrLatnRS from "../locales/coppa/sr-Latn-RS.json";
import coppaSv from "../locales/coppa/sv.json";
import coppaTh from "../locales/coppa/th.json";
import coppaTl from "../locales/coppa/tl.json";
import coppaTr from "../locales/coppa/tr.json";
import coppaUk from "../locales/coppa/uk.json";
import coppaUr from "../locales/coppa/ur.json";
import coppaVi from "../locales/coppa/vi.json";
import coppaZh from "../locales/coppa/zh.json";

// Import Age Estimation locale files
import ageEstimationEn from "../locales/age-estimation/en.json";
import ageEstimationAr from "../locales/age-estimation/ar.json";
import ageEstimationBg from "../locales/age-estimation/bg.json";
import ageEstimationBs from "../locales/age-estimation/bs.json";
import ageEstimationCs from "../locales/age-estimation/cs.json";
import ageEstimationDa from "../locales/age-estimation/da.json";
import ageEstimationDe from "../locales/age-estimation/de.json";
import ageEstimationEl from "../locales/age-estimation/el.json";
import ageEstimationEs from "../locales/age-estimation/es.json";
import ageEstimationEs419 from "../locales/age-estimation/es-419.json";
import ageEstimationEt from "../locales/age-estimation/et.json";
import ageEstimationFa from "../locales/age-estimation/fa.json";
import ageEstimationFi from "../locales/age-estimation/fi.json";
import ageEstimationFr from "../locales/age-estimation/fr.json";
import ageEstimationHe from "../locales/age-estimation/he.json";
import ageEstimationHi from "../locales/age-estimation/hi.json";
import ageEstimationHr from "../locales/age-estimation/hr.json";
import ageEstimationHu from "../locales/age-estimation/hu.json";
import ageEstimationHy from "../locales/age-estimation/hy.json";
import ageEstimationId from "../locales/age-estimation/id.json";
import ageEstimationIt from "../locales/age-estimation/it.json";
import ageEstimationJa from "../locales/age-estimation/ja.json";
import ageEstimationKo from "../locales/age-estimation/ko.json";
import ageEstimationLt from "../locales/age-estimation/lt.json";
import ageEstimationLv from "../locales/age-estimation/lv.json";
import ageEstimationMs from "../locales/age-estimation/ms.json";
import ageEstimationNb from "../locales/age-estimation/nb.json";
import ageEstimationNl from "../locales/age-estimation/nl.json";
import ageEstimationPl from "../locales/age-estimation/pl.json";
import ageEstimationPt from "../locales/age-estimation/pt.json";
import ageEstimationPtBR from "../locales/age-estimation/pt-BR.json";
import ageEstimationRo from "../locales/age-estimation/ro.json";
import ageEstimationRu from "../locales/age-estimation/ru.json";
import ageEstimationSk from "../locales/age-estimation/sk.json";
import ageEstimationSrRS from "../locales/age-estimation/sr-RS.json";
import ageEstimationSrLatnRS from "../locales/age-estimation/sr-Latn-RS.json";
import ageEstimationSv from "../locales/age-estimation/sv.json";
import ageEstimationTh from "../locales/age-estimation/th.json";
import ageEstimationTl from "../locales/age-estimation/tl.json";
import ageEstimationTr from "../locales/age-estimation/tr.json";
import ageEstimationUk from "../locales/age-estimation/uk.json";
import ageEstimationUr from "../locales/age-estimation/ur.json";
import ageEstimationVi from "../locales/age-estimation/vi.json";
import ageEstimationZh from "../locales/age-estimation/zh.json";

// Import Document Capture locale files
import documentCaptureEn from "../locales/document-capture/en.json";
import documentCaptureAr from "../locales/document-capture/ar.json";
import documentCaptureBg from "../locales/document-capture/bg.json";
import documentCaptureBs from "../locales/document-capture/bs.json";
import documentCaptureCs from "../locales/document-capture/cs.json";
import documentCaptureDa from "../locales/document-capture/da.json";
import documentCaptureDe from "../locales/document-capture/de.json";
import documentCaptureEl from "../locales/document-capture/el.json";
import documentCaptureEs from "../locales/document-capture/es.json";
import documentCaptureEs419 from "../locales/document-capture/es-419.json";
import documentCaptureEt from "../locales/document-capture/et.json";
import documentCaptureFa from "../locales/document-capture/fa.json";
import documentCaptureFi from "../locales/document-capture/fi.json";
import documentCaptureFr from "../locales/document-capture/fr.json";
import documentCaptureHe from "../locales/document-capture/he.json";
import documentCaptureHi from "../locales/document-capture/hi.json";
import documentCaptureHr from "../locales/document-capture/hr.json";
import documentCaptureHu from "../locales/document-capture/hu.json";
import documentCaptureHy from "../locales/document-capture/hy.json";
import documentCaptureId from "../locales/document-capture/id.json";
import documentCaptureIt from "../locales/document-capture/it.json";
import documentCaptureJa from "../locales/document-capture/ja.json";
import documentCaptureKo from "../locales/document-capture/ko.json";
import documentCaptureLt from "../locales/document-capture/lt.json";
import documentCaptureLv from "../locales/document-capture/lv.json";
import documentCaptureMs from "../locales/document-capture/ms.json";
import documentCaptureNb from "../locales/document-capture/nb.json";
import documentCaptureNl from "../locales/document-capture/nl.json";
import documentCapturePl from "../locales/document-capture/pl.json";
import documentCapturePt from "../locales/document-capture/pt.json";
import documentCapturePtBR from "../locales/document-capture/pt-BR.json";
import documentCaptureRo from "../locales/document-capture/ro.json";
import documentCaptureRu from "../locales/document-capture/ru.json";
import documentCaptureSk from "../locales/document-capture/sk.json";
import documentCaptureSrRS from "../locales/document-capture/sr-RS.json";
import documentCaptureSrLatnRS from "../locales/document-capture/sr-Latn-RS.json";
import documentCaptureSv from "../locales/document-capture/sv.json";
import documentCaptureTh from "../locales/document-capture/th.json";
import documentCaptureTl from "../locales/document-capture/tl.json";
import documentCaptureTr from "../locales/document-capture/tr.json";
import documentCaptureUk from "../locales/document-capture/uk.json";
import documentCaptureUr from "../locales/document-capture/ur.json";
import documentCaptureVi from "../locales/document-capture/vi.json";
import documentCaptureZh from "../locales/document-capture/zh.json";

// Import Biometric Consent locale files
import biometricConsentEn from "../locales/biometric-consent/en.json";
import biometricConsentAr from "../locales/biometric-consent/ar.json";
import biometricConsentBg from "../locales/biometric-consent/bg.json";
import biometricConsentBs from "../locales/biometric-consent/bs.json";
import biometricConsentCs from "../locales/biometric-consent/cs.json";
import biometricConsentDa from "../locales/biometric-consent/da.json";
import biometricConsentDe from "../locales/biometric-consent/de.json";
import biometricConsentEl from "../locales/biometric-consent/el.json";
import biometricConsentEs from "../locales/biometric-consent/es.json";
import biometricConsentEs419 from "../locales/biometric-consent/es-419.json";
import biometricConsentEt from "../locales/biometric-consent/et.json";
import biometricConsentFa from "../locales/biometric-consent/fa.json";
import biometricConsentFi from "../locales/biometric-consent/fi.json";
import biometricConsentFr from "../locales/biometric-consent/fr.json";
import biometricConsentHe from "../locales/biometric-consent/he.json";
import biometricConsentHi from "../locales/biometric-consent/hi.json";
import biometricConsentHr from "../locales/biometric-consent/hr.json";
import biometricConsentHu from "../locales/biometric-consent/hu.json";
import biometricConsentHy from "../locales/biometric-consent/hy.json";
import biometricConsentId from "../locales/biometric-consent/id.json";
import biometricConsentIt from "../locales/biometric-consent/it.json";
import biometricConsentJa from "../locales/biometric-consent/ja.json";
import biometricConsentKo from "../locales/biometric-consent/ko.json";
import biometricConsentLt from "../locales/biometric-consent/lt.json";
import biometricConsentLv from "../locales/biometric-consent/lv.json";
import biometricConsentMs from "../locales/biometric-consent/ms.json";
import biometricConsentNb from "../locales/biometric-consent/nb.json";
import biometricConsentNl from "../locales/biometric-consent/nl.json";
import biometricConsentPl from "../locales/biometric-consent/pl.json";
import biometricConsentPt from "../locales/biometric-consent/pt.json";
import biometricConsentPtBR from "../locales/biometric-consent/pt-BR.json";
import biometricConsentRo from "../locales/biometric-consent/ro.json";
import biometricConsentRu from "../locales/biometric-consent/ru.json";
import biometricConsentSk from "../locales/biometric-consent/sk.json";
import biometricConsentSrRS from "../locales/biometric-consent/sr-RS.json";
import biometricConsentSrLatnRS from "../locales/biometric-consent/sr-Latn-RS.json";
import biometricConsentSv from "../locales/biometric-consent/sv.json";
import biometricConsentTh from "../locales/biometric-consent/th.json";
import biometricConsentTl from "../locales/biometric-consent/tl.json";
import biometricConsentTr from "../locales/biometric-consent/tr.json";
import biometricConsentUk from "../locales/biometric-consent/uk.json";
import biometricConsentUr from "../locales/biometric-consent/ur.json";
import biometricConsentVi from "../locales/biometric-consent/vi.json";
import biometricConsentZh from "../locales/biometric-consent/zh.json";

// Import Verification Processing locale files
import verificationProcessingEn from "../locales/verification-processing/en.json";
import verificationProcessingAr from "../locales/verification-processing/ar.json";
import verificationProcessingBg from "../locales/verification-processing/bg.json";
import verificationProcessingBs from "../locales/verification-processing/bs.json";
import verificationProcessingCs from "../locales/verification-processing/cs.json";
import verificationProcessingDa from "../locales/verification-processing/da.json";
import verificationProcessingDe from "../locales/verification-processing/de.json";
import verificationProcessingEl from "../locales/verification-processing/el.json";
import verificationProcessingEs from "../locales/verification-processing/es.json";
import verificationProcessingEs419 from "../locales/verification-processing/es-419.json";
import verificationProcessingEt from "../locales/verification-processing/et.json";
import verificationProcessingFa from "../locales/verification-processing/fa.json";
import verificationProcessingFi from "../locales/verification-processing/fi.json";
import verificationProcessingFr from "../locales/verification-processing/fr.json";
import verificationProcessingHe from "../locales/verification-processing/he.json";
import verificationProcessingHi from "../locales/verification-processing/hi.json";
import verificationProcessingHr from "../locales/verification-processing/hr.json";
import verificationProcessingHu from "../locales/verification-processing/hu.json";
import verificationProcessingHy from "../locales/verification-processing/hy.json";
import verificationProcessingId from "../locales/verification-processing/id.json";
import verificationProcessingIt from "../locales/verification-processing/it.json";
import verificationProcessingJa from "../locales/verification-processing/ja.json";
import verificationProcessingKo from "../locales/verification-processing/ko.json";
import verificationProcessingLt from "../locales/verification-processing/lt.json";
import verificationProcessingLv from "../locales/verification-processing/lv.json";
import verificationProcessingMs from "../locales/verification-processing/ms.json";
import verificationProcessingNb from "../locales/verification-processing/nb.json";
import verificationProcessingNl from "../locales/verification-processing/nl.json";
import verificationProcessingPl from "../locales/verification-processing/pl.json";
import verificationProcessingPt from "../locales/verification-processing/pt.json";
import verificationProcessingPtBR from "../locales/verification-processing/pt-BR.json";
import verificationProcessingRo from "../locales/verification-processing/ro.json";
import verificationProcessingRu from "../locales/verification-processing/ru.json";
import verificationProcessingSk from "../locales/verification-processing/sk.json";
import verificationProcessingSrRS from "../locales/verification-processing/sr-RS.json";
import verificationProcessingSrLatnRS from "../locales/verification-processing/sr-Latn-RS.json";
import verificationProcessingSv from "../locales/verification-processing/sv.json";
import verificationProcessingTh from "../locales/verification-processing/th.json";
import verificationProcessingTl from "../locales/verification-processing/tl.json";
import verificationProcessingTr from "../locales/verification-processing/tr.json";
import verificationProcessingUk from "../locales/verification-processing/uk.json";
import verificationProcessingUr from "../locales/verification-processing/ur.json";
import verificationProcessingVi from "../locales/verification-processing/vi.json";
import verificationProcessingZh from "../locales/verification-processing/zh.json";

// Import Face Capture locale files
import faceCaptureEn from "../locales/face-capture/en.json";
import faceCaptureAr from "../locales/face-capture/ar.json";
import faceCaptureBg from "../locales/face-capture/bg.json";
import faceCaptureBs from "../locales/face-capture/bs.json";
import faceCaptureCs from "../locales/face-capture/cs.json";
import faceCaptureDa from "../locales/face-capture/da.json";
import faceCaptureDe from "../locales/face-capture/de.json";
import faceCaptureEl from "../locales/face-capture/el.json";
import faceCaptureEs from "../locales/face-capture/es.json";
import faceCaptureEs419 from "../locales/face-capture/es-419.json";
import faceCaptureEt from "../locales/face-capture/et.json";
import faceCaptureFa from "../locales/face-capture/fa.json";
import faceCaptureFi from "../locales/face-capture/fi.json";
import faceCaptureFr from "../locales/face-capture/fr.json";
import faceCaptureHe from "../locales/face-capture/he.json";
import faceCaptureHi from "../locales/face-capture/hi.json";
import faceCaptureHr from "../locales/face-capture/hr.json";
import faceCaptureHu from "../locales/face-capture/hu.json";
import faceCaptureHy from "../locales/face-capture/hy.json";
import faceCaptureId from "../locales/face-capture/id.json";
import faceCaptureIt from "../locales/face-capture/it.json";
import faceCaptureJa from "../locales/face-capture/ja.json";
import faceCaptureKo from "../locales/face-capture/ko.json";
import faceCaptureLt from "../locales/face-capture/lt.json";
import faceCaptureLv from "../locales/face-capture/lv.json";
import faceCaptureMs from "../locales/face-capture/ms.json";
import faceCaptureNb from "../locales/face-capture/nb.json";
import faceCaptureNl from "../locales/face-capture/nl.json";
import faceCapturePl from "../locales/face-capture/pl.json";
import faceCapturePt from "../locales/face-capture/pt.json";
import faceCapturePtBR from "../locales/face-capture/pt-BR.json";
import faceCaptureRo from "../locales/face-capture/ro.json";
import faceCaptureRu from "../locales/face-capture/ru.json";
import faceCaptureSk from "../locales/face-capture/sk.json";
import faceCaptureSrRS from "../locales/face-capture/sr-RS.json";
import faceCaptureSrLatnRS from "../locales/face-capture/sr-Latn-RS.json";
import faceCaptureSv from "../locales/face-capture/sv.json";
import faceCaptureTh from "../locales/face-capture/th.json";
import faceCaptureTl from "../locales/face-capture/tl.json";
import faceCaptureTr from "../locales/face-capture/tr.json";
import faceCaptureUk from "../locales/face-capture/uk.json";
import faceCaptureUr from "../locales/face-capture/ur.json";
import faceCaptureVi from "../locales/face-capture/vi.json";
import faceCaptureZh from "../locales/face-capture/zh.json";

// Import KBA Transition locale files
import verificationTransitionEn from "../locales/verification-transition/en.json";
import verificationTransitionAr from "../locales/verification-transition/ar.json";
import verificationTransitionBg from "../locales/verification-transition/bg.json";
import verificationTransitionBs from "../locales/verification-transition/bs.json";
import verificationTransitionCs from "../locales/verification-transition/cs.json";
import verificationTransitionDa from "../locales/verification-transition/da.json";
import verificationTransitionDe from "../locales/verification-transition/de.json";
import verificationTransitionEl from "../locales/verification-transition/el.json";
import verificationTransitionEs from "../locales/verification-transition/es.json";
import verificationTransitionEs419 from "../locales/verification-transition/es-419.json";
import verificationTransitionEt from "../locales/verification-transition/et.json";
import verificationTransitionFa from "../locales/verification-transition/fa.json";
import verificationTransitionFi from "../locales/verification-transition/fi.json";
import verificationTransitionFr from "../locales/verification-transition/fr.json";
import verificationTransitionHe from "../locales/verification-transition/he.json";
import verificationTransitionHi from "../locales/verification-transition/hi.json";
import verificationTransitionHr from "../locales/verification-transition/hr.json";
import verificationTransitionHu from "../locales/verification-transition/hu.json";
import verificationTransitionHy from "../locales/verification-transition/hy.json";
import verificationTransitionId from "../locales/verification-transition/id.json";
import verificationTransitionIt from "../locales/verification-transition/it.json";
import verificationTransitionJa from "../locales/verification-transition/ja.json";
import verificationTransitionKo from "../locales/verification-transition/ko.json";
import verificationTransitionLt from "../locales/verification-transition/lt.json";
import verificationTransitionLv from "../locales/verification-transition/lv.json";
import verificationTransitionMs from "../locales/verification-transition/ms.json";
import verificationTransitionNb from "../locales/verification-transition/nb.json";
import verificationTransitionNl from "../locales/verification-transition/nl.json";
import verificationTransitionPl from "../locales/verification-transition/pl.json";
import verificationTransitionPt from "../locales/verification-transition/pt.json";
import verificationTransitionPtBR from "../locales/verification-transition/pt-BR.json";
import verificationTransitionRo from "../locales/verification-transition/ro.json";
import verificationTransitionRu from "../locales/verification-transition/ru.json";
import verificationTransitionSk from "../locales/verification-transition/sk.json";
import verificationTransitionSrRS from "../locales/verification-transition/sr-RS.json";
import verificationTransitionSrLatnRS from "../locales/verification-transition/sr-Latn-RS.json";
import verificationTransitionSv from "../locales/verification-transition/sv.json";
import verificationTransitionTh from "../locales/verification-transition/th.json";
import verificationTransitionTl from "../locales/verification-transition/tl.json";
import verificationTransitionTr from "../locales/verification-transition/tr.json";
import verificationTransitionUk from "../locales/verification-transition/uk.json";
import verificationTransitionUr from "../locales/verification-transition/ur.json";
import verificationTransitionVi from "../locales/verification-transition/vi.json";
import verificationTransitionZh from "../locales/verification-transition/zh.json";

// Import Passkey locale files
import passkeyEn from "../locales/passkey/en.json";
import passkeyAr from "../locales/passkey/ar.json";
import passkeyBg from "../locales/passkey/bg.json";
import passkeyBs from "../locales/passkey/bs.json";
import passkeyCs from "../locales/passkey/cs.json";
import passkeyDa from "../locales/passkey/da.json";
import passkeyDe from "../locales/passkey/de.json";
import passkeyEl from "../locales/passkey/el.json";
import passkeyEs from "../locales/passkey/es.json";
import passkeyEs419 from "../locales/passkey/es-419.json";
import passkeyEt from "../locales/passkey/et.json";
import passkeyFa from "../locales/passkey/fa.json";
import passkeyFi from "../locales/passkey/fi.json";
import passkeyFr from "../locales/passkey/fr.json";
import passkeyHe from "../locales/passkey/he.json";
import passkeyHi from "../locales/passkey/hi.json";
import passkeyHr from "../locales/passkey/hr.json";
import passkeyHu from "../locales/passkey/hu.json";
import passkeyHy from "../locales/passkey/hy.json";
import passkeyId from "../locales/passkey/id.json";
import passkeyIt from "../locales/passkey/it.json";
import passkeyJa from "../locales/passkey/ja.json";
import passkeyKo from "../locales/passkey/ko.json";
import passkeyLt from "../locales/passkey/lt.json";
import passkeyLv from "../locales/passkey/lv.json";
import passkeyMs from "../locales/passkey/ms.json";
import passkeyNb from "../locales/passkey/nb.json";
import passkeyNl from "../locales/passkey/nl.json";
import passkeyPl from "../locales/passkey/pl.json";
import passkeyPt from "../locales/passkey/pt.json";
import passkeyPtBR from "../locales/passkey/pt-BR.json";
import passkeyRo from "../locales/passkey/ro.json";
import passkeyRu from "../locales/passkey/ru.json";
import passkeySk from "../locales/passkey/sk.json";
import passkeySrRS from "../locales/passkey/sr-RS.json";
import passkeySrLatnRS from "../locales/passkey/sr-Latn-RS.json";
import passkeySv from "../locales/passkey/sv.json";
import passkeyTh from "../locales/passkey/th.json";
import passkeyTl from "../locales/passkey/tl.json";
import passkeyTr from "../locales/passkey/tr.json";
import passkeyUk from "../locales/passkey/uk.json";
import passkeyUr from "../locales/passkey/ur.json";
import passkeyVi from "../locales/passkey/vi.json";
import passkeyZh from "../locales/passkey/zh.json";

// Import Footer locale files
import footerEn from "../locales/footer/en.json";
import footerAr from "../locales/footer/ar.json";
import footerBg from "../locales/footer/bg.json";
import footerBs from "../locales/footer/bs.json";
import footerCs from "../locales/footer/cs.json";
import footerDa from "../locales/footer/da.json";
import footerDe from "../locales/footer/de.json";
import footerEl from "../locales/footer/el.json";
import footerEs from "../locales/footer/es.json";
import footerEs419 from "../locales/footer/es-419.json";
import footerEt from "../locales/footer/et.json";
import footerFa from "../locales/footer/fa.json";
import footerFi from "../locales/footer/fi.json";
import footerFr from "../locales/footer/fr.json";
import footerHe from "../locales/footer/he.json";
import footerHi from "../locales/footer/hi.json";
import footerHr from "../locales/footer/hr.json";
import footerHu from "../locales/footer/hu.json";
import footerHy from "../locales/footer/hy.json";
import footerId from "../locales/footer/id.json";
import footerIt from "../locales/footer/it.json";
import footerJa from "../locales/footer/ja.json";
import footerKo from "../locales/footer/ko.json";
import footerLt from "../locales/footer/lt.json";
import footerLv from "../locales/footer/lv.json";
import footerMs from "../locales/footer/ms.json";
import footerNb from "../locales/footer/nb.json";
import footerNl from "../locales/footer/nl.json";
import footerPl from "../locales/footer/pl.json";
import footerPt from "../locales/footer/pt.json";
import footerPtBr from "../locales/footer/pt-BR.json";
import footerRo from "../locales/footer/ro.json";
import footerRu from "../locales/footer/ru.json";
import footerSk from "../locales/footer/sk.json";
import footerSrRs from "../locales/footer/sr-RS.json";
import footerSrLatnRs from "../locales/footer/sr-Latn-RS.json";
import footerSv from "../locales/footer/sv.json";
import footerTh from "../locales/footer/th.json";
import footerTl from "../locales/footer/tl.json";
import footerTr from "../locales/footer/tr.json";
import footerUk from "../locales/footer/uk.json";
import footerUr from "../locales/footer/ur.json";
import footerVi from "../locales/footer/vi.json";
import footerZh from "../locales/footer/zh.json";

const locales = {
  idmatchplus: {
    en: idmatchplusEn,
    es: idmatchplusEs,
  },
  handoff: {
    en: handoffEn,
    ar: handoffAr,
    bg: handoffBg,
    bs: handoffBs,
    cs: handoffCs,
    da: handoffDa,
    de: handoffDe,
    el: handoffEl,
    es: handoffEs,
    "es-419": handoffEs419,
    et: handoffEt,
    fa: handoffFa,
    fi: handoffFi,
    fr: handoffFr,
    he: handoffHe,
    hi: handoffHi,
    hr: handoffHr,
    hu: handoffHu,
    hy: handoffHy,
    id: handoffId,
    it: handoffIt,
    ja: handoffJa,
    ko: handoffKo,
    lt: handoffLt,
    lv: handoffLv,
    ms: handoffMs,
    nb: handoffNb,
    nl: handoffNl,
    pl: handoffPl,
    pt: handoffPt,
    "pt-BR": handoffPtBR,
    ro: handoffRo,
    ru: handoffRu,
    sk: handoffSk,
    "sr-RS": handoffSrRS,
    "sr-Latn-RS": handoffSrLatnRS,
    sv: handoffSv,
    th: handoffTh,
    tl: handoffTl,
    tr: handoffTr,
    uk: handoffUk,
    ur: handoffUr,
    vi: handoffVi,
    zh: handoffZh,
  },
  footer: {
    en: footerEn,
    ar: footerAr,
    bg: footerBg,
    bs: footerBs,
    cs: footerCs,
    da: footerDa,
    de: footerDe,
    el: footerEl,
    es: footerEs,
    "es-419": footerEs419,
    et: footerEt,
    fa: footerFa,
    fi: footerFi,
    fr: footerFr,
    he: footerHe,
    hi: footerHi,
    hr: footerHr,
    hu: footerHu,
    hy: footerHy,
    id: footerId,
    it: footerIt,
    ja: footerJa,
    ko: footerKo,
    lt: footerLt,
    lv: footerLv,
    ms: footerMs,
    nb: footerNb,
    nl: footerNl,
    pl: footerPl,
    pt: footerPt,
    "pt-BR": footerPtBr,
    ro: footerRo,
    ru: footerRu,
    sk: footerSk,
    "sr-RS": footerSrRs,
    "sr-Latn-RS": footerSrLatnRs,
    sv: footerSv,
    th: footerTh,
    tl: footerTl,
    tr: footerTr,
    uk: footerUk,
    ur: footerUr,
    vi: footerVi,
    zh: footerZh,
  },
  "agematch": {
    ar: agematchAr,
    bg: agematchBg,
    bs: agematchBs,
    cs: agematchCs,
    da: agematchDa,
    de: agematchDe,
    el: agematchEl,
    en: agematchEn,
    "es-419": agematchEs419,
    es: agematchEs,
    et: agematchEt,
    fa: agematchFa,
    fi: agematchFi,
    fr: agematchFr,
    he: agematchHe,
    hi: agematchHi,
    hr: agematchHr,
    hu: agematchHu,
    hy: agematchHy,
    id: agematchId,
    it: agematchIt,
    ja: agematchJa,
    ko: agematchKo,
    lt: agematchLt,
    lv: agematchLv,
    ms: agematchMs,
    nb: agematchNb,
    nl: agematchNl,
    pl: agematchPl,
    "pt-BR": agematchPtBR,
    pt: agematchPt,
    ro: agematchRo,
    ru: agematchRu,
    sk: agematchSk,
    "sr-Latn-RS": agematchSrLatnRS,
    "sr-RS": agematchSrRS,
    sv: agematchSv,
    th: agematchTh,
    tl: agematchTl,
    tr: agematchTr,
    uk: agematchUk,
    ur: agematchUr,
    vi: agematchVi,
    zh: agematchZh,
  },
  "brazil-cpf": {
    ar: brazilCpfAr,
    bg: brazilCpfBg,
    bs: brazilCpfBs,
    cs: brazilCpfCs,
    da: brazilCpfDa,
    de: brazilCpfDe,
    el: brazilCpfEl,
    en: brazilCpfEn,
    "es-419": brazilCpfEs419,
    es: brazilCpfEs,
    et: brazilCpfEt,
    fa: brazilCpfFa,
    fi: brazilCpfFi,
    fr: brazilCpfFr,
    he: brazilCpfHe,
    hi: brazilCpfHi,
    hr: brazilCpfHr,
    hu: brazilCpfHu,
    hy: brazilCpfHy,
    id: brazilCpfId,
    it: brazilCpfIt,
    ja: brazilCpfJa,
    ko: brazilCpfKo,
    lt: brazilCpfLt,
    lv: brazilCpfLv,
    ms: brazilCpfMs,
    nb: brazilCpfNb,
    nl: brazilCpfNl,
    pl: brazilCpfPl,
    "pt-BR": brazilCpfPtBR,
    pt: brazilCpfPt,
    ro: brazilCpfRo,
    ru: brazilCpfRu,
    sk: brazilCpfSk,
    "sr-Latn-RS": brazilCpfSrLatnRS,
    "sr-RS": brazilCpfSrRS,
    sv: brazilCpfSv,
    th: brazilCpfTh,
    tl: brazilCpfTl,
    tr: brazilCpfTr,
    uk: brazilCpfUk,
    ur: brazilCpfUr,
    vi: brazilCpfVi,
    zh: brazilCpfZh,
  },
  mojeid: {
    en: mojeidEn,
    cs: mojeidCs,
  },
  "bankid-cz": {
    en: bankidCzEn,
    cs: bankidCzCs,
  },
  "bankid-se": {
    en: bankidSeEn,
    sv: bankidSeSv,
  },
  "bankid-no": {
    en: bankidNoEn,
    nb: bankidNoNb,
  },
  "finnish-trust-network": {
    en: finnishTrustNetworkEn,
    fi: finnishTrustNetworkFi,
  },
  modular: {
    en: modularEn,
    cs: modularCs,
    fi: modularFi,
  },
  coppa: {
    en: coppaEn,
    ar: coppaAr,
    bg: coppaBg,
    bs: coppaBs,
    cs: coppaCs,
    da: coppaDa,
    de: coppaDe,
    el: coppaEl,
    es: coppaEs,
    "es-419": coppaEs419,
    et: coppaEt,
    fa: coppaFa,
    fi: coppaFi,
    fr: coppaFr,
    he: coppaHe,
    hi: coppaHi,
    hr: coppaHr,
    hu: coppaHu,
    hy: coppaHy,
    id: coppaId,
    it: coppaIt,
    ja: coppaJa,
    ko: coppaKo,
    lt: coppaLt,
    lv: coppaLv,
    ms: coppaMs,
    nb: coppaNb,
    nl: coppaNl,
    pl: coppaPl,
    pt: coppaPt,
    "pt-BR": coppaPtBR,
    ro: coppaRo,
    ru: coppaRu,
    sk: coppaSk,
    "sr-RS": coppaSrRS,
    "sr-Latn-RS": coppaSrLatnRS,
    sv: coppaSv,
    th: coppaTh,
    tl: coppaTl,
    tr: coppaTr,
    uk: coppaUk,
    ur: coppaUr,
    vi: coppaVi,
    zh: coppaZh,
  },
  "device-blocked": {
    en: deviceBlockedEn,
    ar: deviceBlockedAr,
    bg: deviceBlockedBg,
    bs: deviceBlockedBs,
    cs: deviceBlockedCs,
    da: deviceBlockedDa,
    de: deviceBlockedDe,
    el: deviceBlockedEl,
    es: deviceBlockedEs,
    "es-419": deviceBlockedEs419,
    et: deviceBlockedEt,
    fa: deviceBlockedFa,
    fi: deviceBlockedFi,
    fr: deviceBlockedFr,
    he: deviceBlockedHe,
    hi: deviceBlockedHi,
    hr: deviceBlockedHr,
    hu: deviceBlockedHu,
    hy: deviceBlockedHy,
    id: deviceBlockedId,
    it: deviceBlockedIt,
    ja: deviceBlockedJa,
    ko: deviceBlockedKo,
    lt: deviceBlockedLt,
    lv: deviceBlockedLv,
    ms: deviceBlockedMs,
    nb: deviceBlockedNb,
    nl: deviceBlockedNl,
    pl: deviceBlockedPl,
    pt: deviceBlockedPt,
    "pt-BR": deviceBlockedPtBR,
    ro: deviceBlockedRo,
    ru: deviceBlockedRu,
    sk: deviceBlockedSk,
    "sr-RS": deviceBlockedSrRS,
    "sr-Latn-RS": deviceBlockedSrLatnRS,
    sv: deviceBlockedSv,
    th: deviceBlockedTh,
    tl: deviceBlockedTl,
    tr: deviceBlockedTr,
    uk: deviceBlockedUk,
    ur: deviceBlockedUr,
    vi: deviceBlockedVi,
    zh: deviceBlockedZh,
  },
  "document-capture": {
    en: documentCaptureEn,
    ar: documentCaptureAr,
    bg: documentCaptureBg,
    bs: documentCaptureBs,
    cs: documentCaptureCs,
    da: documentCaptureDa,
    de: documentCaptureDe,
    el: documentCaptureEl,
    es: documentCaptureEs,
    "es-419": documentCaptureEs419,
    et: documentCaptureEt,
    fa: documentCaptureFa,
    fi: documentCaptureFi,
    fr: documentCaptureFr,
    he: documentCaptureHe,
    hi: documentCaptureHi,
    hr: documentCaptureHr,
    hu: documentCaptureHu,
    hy: documentCaptureHy,
    id: documentCaptureId,
    it: documentCaptureIt,
    ja: documentCaptureJa,
    ko: documentCaptureKo,
    lt: documentCaptureLt,
    lv: documentCaptureLv,
    ms: documentCaptureMs,
    nb: documentCaptureNb,
    nl: documentCaptureNl,
    pl: documentCapturePl,
    pt: documentCapturePt,
    "pt-BR": documentCapturePtBR,
    ro: documentCaptureRo,
    ru: documentCaptureRu,
    sk: documentCaptureSk,
    "sr-RS": documentCaptureSrRS,
    "sr-Latn-RS": documentCaptureSrLatnRS,
    sv: documentCaptureSv,
    th: documentCaptureTh,
    tl: documentCaptureTl,
    tr: documentCaptureTr,
    uk: documentCaptureUk,
    ur: documentCaptureUr,
    vi: documentCaptureVi,
    zh: documentCaptureZh,
  },
  "biometric-consent": {
    en: biometricConsentEn,
    ar: biometricConsentAr,
    bg: biometricConsentBg,
    bs: biometricConsentBs,
    cs: biometricConsentCs,
    da: biometricConsentDa,
    de: biometricConsentDe,
    el: biometricConsentEl,
    es: biometricConsentEs,
    "es-419": biometricConsentEs419,
    et: biometricConsentEt,
    fa: biometricConsentFa,
    fi: biometricConsentFi,
    fr: biometricConsentFr,
    he: biometricConsentHe,
    hi: biometricConsentHi,
    hr: biometricConsentHr,
    hu: biometricConsentHu,
    hy: biometricConsentHy,
    id: biometricConsentId,
    it: biometricConsentIt,
    ja: biometricConsentJa,
    ko: biometricConsentKo,
    lt: biometricConsentLt,
    lv: biometricConsentLv,
    ms: biometricConsentMs,
    nb: biometricConsentNb,
    nl: biometricConsentNl,
    pl: biometricConsentPl,
    pt: biometricConsentPt,
    "pt-BR": biometricConsentPtBR,
    ro: biometricConsentRo,
    ru: biometricConsentRu,
    sk: biometricConsentSk,
    "sr-RS": biometricConsentSrRS,
    "sr-Latn-RS": biometricConsentSrLatnRS,
    sv: biometricConsentSv,
    th: biometricConsentTh,
    tl: biometricConsentTl,
    tr: biometricConsentTr,
    uk: biometricConsentUk,
    ur: biometricConsentUr,
    vi: biometricConsentVi,
    zh: biometricConsentZh,
  },
  "verification-processing": {
    en: verificationProcessingEn,
    ar: verificationProcessingAr,
    bg: verificationProcessingBg,
    bs: verificationProcessingBs,
    cs: verificationProcessingCs,
    da: verificationProcessingDa,
    de: verificationProcessingDe,
    el: verificationProcessingEl,
    es: verificationProcessingEs,
    "es-419": verificationProcessingEs419,
    et: verificationProcessingEt,
    fa: verificationProcessingFa,
    fi: verificationProcessingFi,
    fr: verificationProcessingFr,
    he: verificationProcessingHe,
    hi: verificationProcessingHi,
    hr: verificationProcessingHr,
    hu: verificationProcessingHu,
    hy: verificationProcessingHy,
    id: verificationProcessingId,
    it: verificationProcessingIt,
    ja: verificationProcessingJa,
    ko: verificationProcessingKo,
    lt: verificationProcessingLt,
    lv: verificationProcessingLv,
    ms: verificationProcessingMs,
    nb: verificationProcessingNb,
    nl: verificationProcessingNl,
    pl: verificationProcessingPl,
    pt: verificationProcessingPt,
    "pt-BR": verificationProcessingPtBR,
    ro: verificationProcessingRo,
    ru: verificationProcessingRu,
    sk: verificationProcessingSk,
    "sr-RS": verificationProcessingSrRS,
    "sr-Latn-RS": verificationProcessingSrLatnRS,
    sv: verificationProcessingSv,
    th: verificationProcessingTh,
    tl: verificationProcessingTl,
    tr: verificationProcessingTr,
    uk: verificationProcessingUk,
    ur: verificationProcessingUr,
    vi: verificationProcessingVi,
    zh: verificationProcessingZh,
  },
  "face-capture": {
    en: faceCaptureEn,
    ar: faceCaptureAr,
    bg: faceCaptureBg,
    bs: faceCaptureBs,
    cs: faceCaptureCs,
    da: faceCaptureDa,
    de: faceCaptureDe,
    el: faceCaptureEl,
    es: faceCaptureEs,
    "es-419": faceCaptureEs419,
    et: faceCaptureEt,
    fa: faceCaptureFa,
    fi: faceCaptureFi,
    fr: faceCaptureFr,
    he: faceCaptureHe,
    hi: faceCaptureHi,
    hr: faceCaptureHr,
    hu: faceCaptureHu,
    hy: faceCaptureHy,
    id: faceCaptureId,
    it: faceCaptureIt,
    ja: faceCaptureJa,
    ko: faceCaptureKo,
    lt: faceCaptureLt,
    lv: faceCaptureLv,
    ms: faceCaptureMs,
    nb: faceCaptureNb,
    nl: faceCaptureNl,
    pl: faceCapturePl,
    pt: faceCapturePt,
    "pt-BR": faceCapturePtBR,
    ro: faceCaptureRo,
    ru: faceCaptureRu,
    sk: faceCaptureSk,
    "sr-RS": faceCaptureSrRS,
    "sr-Latn-RS": faceCaptureSrLatnRS,
    sv: faceCaptureSv,
    th: faceCaptureTh,
    tl: faceCaptureTl,
    tr: faceCaptureTr,
    uk: faceCaptureUk,
    ur: faceCaptureUr,
    vi: faceCaptureVi,
    zh: faceCaptureZh,
  },
  "age-estimation": {
    en: ageEstimationEn,
    ar: ageEstimationAr,
    bg: ageEstimationBg,
    bs: ageEstimationBs,
    cs: ageEstimationCs,
    da: ageEstimationDa,
    de: ageEstimationDe,
    el: ageEstimationEl,
    es: ageEstimationEs,
    "es-419": ageEstimationEs419,
    et: ageEstimationEt,
    fa: ageEstimationFa,
    fi: ageEstimationFi,
    fr: ageEstimationFr,
    he: ageEstimationHe,
    hi: ageEstimationHi,
    hr: ageEstimationHr,
    hu: ageEstimationHu,
    hy: ageEstimationHy,
    id: ageEstimationId,
    it: ageEstimationIt,
    ja: ageEstimationJa,
    ko: ageEstimationKo,
    lt: ageEstimationLt,
    lv: ageEstimationLv,
    ms: ageEstimationMs,
    nb: ageEstimationNb,
    nl: ageEstimationNl,
    pl: ageEstimationPl,
    pt: ageEstimationPt,
    "pt-BR": ageEstimationPtBR,
    ro: ageEstimationRo,
    ru: ageEstimationRu,
    sk: ageEstimationSk,
    "sr-RS": ageEstimationSrRS,
    "sr-Latn-RS": ageEstimationSrLatnRS,
    sv: ageEstimationSv,
    th: ageEstimationTh,
    tl: ageEstimationTl,
    tr: ageEstimationTr,
    uk: ageEstimationUk,
    ur: ageEstimationUr,
    vi: ageEstimationVi,
    zh: ageEstimationZh,
  },
  "verification-transition": {
    en: verificationTransitionEn,
    ar: verificationTransitionAr,
    bg: verificationTransitionBg,
    bs: verificationTransitionBs,
    cs: verificationTransitionCs,
    da: verificationTransitionDa,
    de: verificationTransitionDe,
    el: verificationTransitionEl,
    es: verificationTransitionEs,
    "es-419": verificationTransitionEs419,
    et: verificationTransitionEt,
    fa: verificationTransitionFa,
    fi: verificationTransitionFi,
    fr: verificationTransitionFr,
    he: verificationTransitionHe,
    hi: verificationTransitionHi,
    hr: verificationTransitionHr,
    hu: verificationTransitionHu,
    hy: verificationTransitionHy,
    id: verificationTransitionId,
    it: verificationTransitionIt,
    ja: verificationTransitionJa,
    ko: verificationTransitionKo,
    lt: verificationTransitionLt,
    lv: verificationTransitionLv,
    ms: verificationTransitionMs,
    nb: verificationTransitionNb,
    nl: verificationTransitionNl,
    pl: verificationTransitionPl,
    pt: verificationTransitionPt,
    "pt-BR": verificationTransitionPtBR,
    ro: verificationTransitionRo,
    ru: verificationTransitionRu,
    sk: verificationTransitionSk,
    "sr-RS": verificationTransitionSrRS,
    "sr-Latn-RS": verificationTransitionSrLatnRS,
    sv: verificationTransitionSv,
    th: verificationTransitionTh,
    tl: verificationTransitionTl,
    tr: verificationTransitionTr,
    uk: verificationTransitionUk,
    ur: verificationTransitionUr,
    vi: verificationTransitionVi,
    zh: verificationTransitionZh,
  },
  passkey: {
    en: passkeyEn,
    ar: passkeyAr,
    bg: passkeyBg,
    bs: passkeyBs,
    cs: passkeyCs,
    da: passkeyDa,
    de: passkeyDe,
    el: passkeyEl,
    es: passkeyEs,
    "es-419": passkeyEs419,
    et: passkeyEt,
    fa: passkeyFa,
    fi: passkeyFi,
    fr: passkeyFr,
    he: passkeyHe,
    hi: passkeyHi,
    hr: passkeyHr,
    hu: passkeyHu,
    hy: passkeyHy,
    id: passkeyId,
    it: passkeyIt,
    ja: passkeyJa,
    ko: passkeyKo,
    lt: passkeyLt,
    lv: passkeyLv,
    ms: passkeyMs,
    nb: passkeyNb,
    nl: passkeyNl,
    pl: passkeyPl,
    pt: passkeyPt,
    "pt-BR": passkeyPtBR,
    ro: passkeyRo,
    ru: passkeyRu,
    sk: passkeySk,
    "sr-RS": passkeySrRS,
    "sr-Latn-RS": passkeySrLatnRS,
    sv: passkeySv,
    th: passkeyTh,
    tl: passkeyTl,
    tr: passkeyTr,
    uk: passkeyUk,
    ur: passkeyUr,
    vi: passkeyVi,
    zh: passkeyZh,
  },
  orientation: {
    en: orientationEn,
    ar: orientationAr,
    bg: orientationBg,
    bs: orientationBs,
    cs: orientationCs,
    da: orientationDa,
    de: orientationDe,
    el: orientationEl,
    es: orientationEs,
    "es-419": orientationEs419,
    et: orientationEt,
    fa: orientationFa,
    fi: orientationFi,
    fr: orientationFr,
    he: orientationHe,
    hi: orientationHi,
    hr: orientationHr,
    hu: orientationHu,
    hy: orientationHy,
    id: orientationId,
    it: orientationIt,
    ja: orientationJa,
    ko: orientationKo,
    lt: orientationLt,
    lv: orientationLv,
    ms: orientationMs,
    nb: orientationNb,
    nl: orientationNl,
    pl: orientationPl,
    pt: orientationPt,
    "pt-BR": orientationPtBR,
    ro: orientationRo,
    ru: orientationRu,
    sk: orientationSk,
    "sr-RS": orientationSrRS,
    "sr-Latn-RS": orientationSrLatnRS,
    sv: orientationSv,
    th: orientationTh,
    tl: orientationTl,
    tr: orientationTr,
    uk: orientationUk,
    ur: orientationUr,
    vi: orientationVi,
    zh: orientationZh,
  },
};

/**
 * Recursively merge a primary locale object on top of a fallback (English).
 * Any key the primary defines wins; any key the primary omits falls through
 * to the English value. Prevents crashes when a non-English file is stale
 * relative to en.json (e.g. a new translation key hasn't been added yet).
 */
const deepMergeWithFallback = (primary, fallback) => {
  if (!primary) return fallback;
  if (!fallback) return primary;
  if (typeof primary !== "object" || typeof fallback !== "object") return primary;
  if (Array.isArray(primary) || Array.isArray(fallback)) return primary;
  const result = { ...fallback };
  for (const key of Object.keys(primary)) {
    const p = primary[key];
    const f = fallback[key];
    if (
      p !== null &&
      typeof p === "object" &&
      !Array.isArray(p) &&
      f !== null &&
      typeof f === "object" &&
      !Array.isArray(f)
    ) {
      result[key] = deepMergeWithFallback(p, f);
    } else {
      result[key] = p;
    }
  }
  return result;
};

/**
 * Hook to get localized text for components
 * Supports IDMatchPlus, Brazil CPF, Age Estimation, COPPA, mojeID, BankID CZ, Finnish Trust Network, Modular, Biometric Consent, and Face Capture components
 * Defaults to English if language is not set or unsupported. Non-English
 * locales are deep-merged on top of English so missing keys fall through to
 * the English value instead of rendering as undefined.
 */
// Ambiguous / partial language tags publishers commonly send that
// don't line up with our region-specific file names. Keys are
// lowercase because the resolver lowercases the incoming tag first.
// Serbian is written in two scripts (Cyrillic + Latin); we host the
// Latin translations under `sr-Latn-RS` and the Cyrillic under
// `sr-RS`. Sessions that come in as just `sr`, `sr-Latn`, or
// `sr-Cyrl` (without the region tag) need to be routed to the right
// script file. Default plain `sr` to Latin because it's the more
// universally readable script on modern devices/browsers — sessions
// wanting Cyrillic can pass `sr-Cyrl` or `sr-RS` explicitly.
const LANGUAGE_ALIASES = {
  sr: "sr-Latn-RS",
  "sr-latn": "sr-Latn-RS",
  "sr-cyrl": "sr-RS",
};

const useLocale = (component = "idmatchplus") => {
  const { settings } = useContext(DataContext);

  const locale = useMemo(() => {
    const language = settings?.language?.toLowerCase();
    const componentLocales = locales[component];

    if (!componentLocales) {
      console.warn(`No locales found for component: ${component}`);
      return locales.idmatchplus.en;
    }

    // Default to English if language is not set or empty
    if (!language || language === "" || language === "en") {
      return componentLocales.en;
    }

    // Try exact match first (handles es-419, pt-BR, sr-RS, sr-Latn-RS, etc.)
    if (componentLocales[language]) {
      return deepMergeWithFallback(componentLocales[language], componentLocales.en);
    }

    // Route common ambiguous tags to the concrete file we host
    // (e.g. `sr-latn` → `sr-Latn-RS`). Runs before the case-
    // insensitive lookup so the alias wins even when a similar
    // key exists but differs in script/region.
    if (LANGUAGE_ALIASES[language]) {
      const aliasedKey = LANGUAGE_ALIASES[language];
      if (componentLocales[aliasedKey]) {
        return deepMergeWithFallback(componentLocales[aliasedKey], componentLocales.en);
      }
    }

    // Try with lowercase and normalized format (e.g., pt_br -> pt-BR)
    const normalizedLang = language.replace("_", "-");
    if (componentLocales[normalizedLang]) {
      return deepMergeWithFallback(componentLocales[normalizedLang], componentLocales.en);
    }

    // Case-insensitive key lookup (handles lowercased input vs mixed-case keys like "pt-BR")
    const caseInsensitiveMatch = Object.keys(componentLocales).find(
      (key) => key.toLowerCase() === normalizedLang
    );
    if (caseInsensitiveMatch) {
      return deepMergeWithFallback(componentLocales[caseInsensitiveMatch], componentLocales.en);
    }

    // Try base language (e.g., es-419 -> es, pt-BR -> pt). Same
    // alias-map check applied to the base so `sr-Latn-XX` also
    // resolves correctly.
    const baseLang = language.split("-")[0].split("_")[0];
    if (componentLocales[baseLang]) {
      return deepMergeWithFallback(componentLocales[baseLang], componentLocales.en);
    }
    if (LANGUAGE_ALIASES[baseLang]) {
      const aliasedBase = LANGUAGE_ALIASES[baseLang];
      if (componentLocales[aliasedBase]) {
        return deepMergeWithFallback(componentLocales[aliasedBase], componentLocales.en);
      }
    }

    // Brazil CPF: Portuguese Brazilian support (legacy handling)
    if (component === "brazil-cpf") {
      if (baseLang === "br" || baseLang === "pt" || language === "portuguese") {
        return deepMergeWithFallback(componentLocales["pt-BR"], componentLocales.en);
      }
    }

    // Fallback to English for any unsupported language
    return componentLocales.en;
  }, [settings?.language, component]);

  return locale;
};

export default useLocale;
